import { render, staticRenderFns } from "./addFileModel.vue?vue&type=template&id=012cbc84&scoped=true"
import script from "./addFileModel.vue?vue&type=script&lang=js"
export * from "./addFileModel.vue?vue&type=script&lang=js"
import style0 from "./addFileModel.vue?vue&type=style&index=0&id=012cbc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cbc84",
  null
  
)

export default component.exports